import { render, staticRenderFns } from "./AppRelease.vue?vue&type=template&id=036b011b&scoped=true"
import script from "./AppRelease.vue?vue&type=script&lang=js"
export * from "./AppRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b011b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/rouvenpajewski/Documents/Projekte/kuipers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036b011b')) {
      api.createRecord('036b011b', component.options)
    } else {
      api.reload('036b011b', component.options)
    }
    module.hot.accept("./AppRelease.vue?vue&type=template&id=036b011b&scoped=true", function () {
      api.rerender('036b011b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/vue/AppRelease.vue"
export default component.exports